/**
 * The full-page loading signature: a thin accent line sweeping a hairline rail.
 *
 * For whole-screen waits only — the initial session check, the first-run status
 * check. Tables and cards use Skeleton instead, because a full-page loader for a
 * small async action makes the whole interface feel like it restarted.
 */
export function BrandLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      className="flex h-dvh flex-col items-center justify-center gap-4 bg-background"
      role="status"
      aria-live="polite"
    >
      <div className="relative h-px w-24 overflow-hidden bg-line-hairline">
        {/* lp-sweep-bar, not the raw keyframes: the sweep must travel in the
            reading direction, and transforms do not flip with `dir`. */}
        <div className="lp-sweep-bar absolute inset-y-0 start-0 w-1/3 bg-accent-500" />
      </div>
      <span className="text-xs text-muted-subtle">{label}</span>
    </div>
  );
}
